module.exports = __webpack_public_path__ + "media/customizations/viridian/chat-bubble-38997a261d9028392d3ebf1acc66e9cb.png";